export default "__VITE_ASSET__$pUkRkcE__"